import { render, staticRenderFns } from "./UpdatePasswordStep.vue?vue&type=template&id=481b79bc&"
import script from "./UpdatePasswordStep.vue?vue&type=script&lang=js&"
export * from "./UpdatePasswordStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports